export class SafetyFeedback {
    id!: string
    indexId!: number
    job?: string | null
    eventDateTime?: Date | string | null
    divisionId?: string | null
    employeeUserId?: string | null
    eventDescription?: string | null
    causes?: string | null
    correctiveActions?: string | null
    reportedTo?: string | null
    positiveFeedback?: string | null
    requiresJha = false
    linkedJobHazardAnalysisId?: string | null
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean
    imageUrls: string[] = []
    imageFileNames: string[] = []

    // Populated by the API from the linked JHA (not sent back on save).
    linkedJhaIndexId?: number | null
    linkedJhaStatus?: string | null

    // Display label used by the grid/modal to show whether the JHA has been addressed.
    get jhaStatusDisplay(): string {
        if (!this.requiresJha) return ''
        if (this.linkedJhaStatus === 'Submitted') return 'Addressed'
        if (this.linkedJobHazardAnalysisId && this.linkedJhaStatus) return 'JHA in progress'
        return 'Needs JHA'
    }
}
